<template>
  <a-row :gutter="24">
    <a-col :md="24">
      <a-card :style="cardStyle1" :bordered="false">
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
          <!-- 搜索区域 -->
          <a-form layout="inline" @keyup.enter.native="searchQuery">
              <a-row :gutter="24">
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-form-item label="核验单号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input placeholder="请输入核验单号" v-model="topQueryParam.verificationBillNo"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-form-item label="出库单号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input placeholder="请输入出库单号" v-model="topQueryParam.outBillNo"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-form-item label="随货同行单号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input placeholder="请输入随货同行单号" v-model="topQueryParam.withOrderBillNo"></a-input>
                  </a-form-item>
                </a-col>
                <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                  <a-col :md="8" :lg="6"  :sm="24">
                    <a-button type="primary" @click="searchQuery">查询</a-button>
                    <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>

                  </a-col>
                </span>

              </a-row>

            </a-form>
        </div>
        <!-- 操作按钮区域 -->
        <!-- table区域-begin -->
        <div>
          <a-table ref="table" size="middle" bordered
              :rowKey="(record,index)=>{return index}" :columns="columns"
              :dataSource="dataSource" :components="handleDrag(columns)"
              :pagination="ipagination" :loading="loading"
               @change="handleTableChange">
              <span slot="action" slot-scope="text, record">
                <a type="primary" @click="getDetail(record)">详情</a>
                <a-divider type="vertical" />
                <a type="primary" @click="synchronous(record)">同步追溯</a>
                <a-divider type="vertical" />
                <!-- <a type="primary" @click="uploadTraceability(record)">入库</a>
                <a-divider type="vertical" /> -->
                <a type="primary" @click="handleExportXls('文件', record)">导出</a>
                <a-divider type="vertical" />

                <a type="primary" @click="delConfirm(handleDelete, record.id)">删除</a>

              </span>
              <template slot="createTime" slot-scope="createTime">
                <span>{{changetime(createTime)}}</span>
              </template>
              <template slot="state" slot-scope="state">
                <a-tag color="blue" v-if="state === 0">审核中</a-tag>
                <a-tag color="green" v-else-if="state === 1">审核通过</a-tag>
                <a-tag color="red" v-else-if="state === 2">未通过审核</a-tag>
              </template>
              <template slot="getCode" slot-scope="text, record">
                <span @click="getCodes(record)" style="cursor: pointer; color: #1890FF;">{{record.outBillNo}}</span>
              </template>
              <!-- 随货同行单点击弹窗 -->
              <template slot="companionNumber" slot-scope="text, record">
                <span v-if="['0','2'].includes(record.verificationMethods+'')" style="color: #888888;">{{record.withOrderBillNo}}</span>
                <span v-else @click="companionNumber(record)" style="cursor: pointer; color: #1890FF;">{{record.withOrderBillNo}}</span>
              </template>
            </a-table>
        </div>
        <!-- table区域-end -->
        <!-- 表单区域 -->

        <inspectionDetail ref="modalDetail" @ok="modalDetailOk" @close="modalDetailClose"></inspectionDetail>
        <outProduct ref="modalOutProduct" @ok="modalDetailOk" @close="modalDetailClose"></outProduct>
      </a-card>
    </a-col>
  </a-row>
</template>
<!-- create ji sheng hua-->
<script>
import outProduct from './modules/outProduct'
import inspectionDetail from './modules/inspectionDetail'
import { campListMixins } from './mixins/campListMixins'
import { exportProductList, synchronousTraceability  } from '@/api/api'
import { PIadmin, tongxingdan } from '@/api/manage'
import JDate from '@/components/jeecg/JDate'
import { getNowFormatStr } from '@/utils/util'

export default {
  name: 'inspection',
  mixins: [campListMixins],
  components: {
    outProduct,
    inspectionDetail,
    JDate,
  },
  data() {
    return {
      ipagination: {
        pageSizeOptions: ['10', '20', '30', '100', '200'],
      },
      // 查询条件
      topQueryParam: {
        verificationBillNo: '',
        outBillNo: '',
        withOrderBillNo: '',
      },
      prefixNo: 'LSCK',
      labelCol: {
        span: 5,
      },
      wrapperCol: {
        span: 18,
        offset: 1,
      },

      // 默认列
      columns: [
        { title: '序号', dataIndex: 'index', width: 50, customRender:(text,record,index) =>`${index + 1}`},
        { title: '核验单号', dataIndex: 'verificationBillNo', width: 120, render: (text) => text || "--"},
        { title: '出库单号', dataIndex: 'outBillNo', width: 120, render: (text) => text || "--", scopedSlots: { customRender: 'getCode' }},
        { title: '随货同行单号', dataIndex: 'withOrderBillNo', width: 120, render: (text) => text || "--",scopedSlots: { customRender: 'companionNumber' }},
        { title: '商品总数', dataIndex: 'totalNum', width: 60, render: (text) => text || "--"},
        { title: '出库方', dataIndex: 'outPartyName', width: 120,render: (text) => text || "--"},
        // { title: '接收方', dataIndex: 'receiverName', width: 120, render: (text) => text || "--" },
        { title: '核验人', dataIndex: 'validatorName', width: 100, render: (text) => text || "--" },
        { title: '核验时间', dataIndex: 'validateEndTime', width: 100, render: (text) => text || "--" },
        {
            title: '操作',
            dataIndex: 'action',
            align: 'center',
            width: 190,
            scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: '/hy/bill/hyBillRecord/list',
        delete:'/hy/bill/hyBillRecord/delete'
      },
      ul: {
        toExcel: '/hy/bill/hyBillRecord/exportValidationExcelRecordId'
      }
    }
  },
  computed: {},
  created() {

  },
  methods: {

    changetime(createTime) {
      return createTime.replace('T', ' ')
    },
    //打开详情
    async getDetail(record){
      console.log(record,'详细信息=======================')
      this.$refs.modalDetail.initShow(record)
    },
    // 导出
    async synchronous(e){
      let params = {
        recordId : e.id
      }
      const res = await synchronousTraceability(params)
      if (res.code == 200 && res.success == true) {
          console.log(res)
          this.$message.success(res.message)
      } else {
          this.$message.error(res.message)
      }
    },
    // 根据出库单号获取code
    getCodes(record){
      this.$refs.modalOutProduct.initShow(record)
    },
    // 根据随货同行单号获取code
    companionNumber(res){
      let arr = []

      arr.push(res.verificationBillNo)
      arr.push(res.outBillNo)

      const fileName = arr.join('-')

      tongxingdan('/depotHead/exportPeerList', {number:res.withOrderBillNo}).then((data) => {
        if (!data) {
          this.$message.warning("文件下载失败")
          return
        }
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          window.navigator.msSaveBlob(new Blob([data], { type: 'application/vnd.ms-excel' }), fileName + '.xls')
        } else {
          let url = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.ms-excel' }))
          let link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          link.setAttribute('download', fileName + '.xls')
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link) //下载完成移除元素
          window.URL.revokeObjectURL(url) //释放掉blob对象
        }
      })
    },
    //daochu
    handleExportXls(fileName, res) {
      console.log(fileName,res,'0909090')
      let params = {
        recordId: res.id
      }
      if (!fileName || typeof fileName != "string") {
        fileName = "导出文件"
      }
      let searchObj = {}
      // searchObj.search = JSON.stringify(this.topQueryParam)
      searchObj.search = this.searchParam
      PIadmin(this.ul.toExcel, params).then((data) => {
        console.log(data,'===============data============')
        if (!data) {
          this.$message.warning("文件下载失败")
          return
        }
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          window.navigator.msSaveBlob(new Blob([data], { type: 'application/vnd.ms-excel' }), fileName + '.xls')
        } else {
          let url = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.ms-excel' }))
          let link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          link.setAttribute('download', fileName + '_' + getNowFormatStr() + '.xls')
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link) //下载完成移除元素
          window.URL.revokeObjectURL(url) //释放掉blob对象
        }
      })
    },

    //daochu
    modalFormOk(){
      this.loadData()
    },
    modalFormClose(){
      this.loadData()
    },
    modalLicenseOk(){
      this.loadData()
    },
    modalLicenseClose(){
      this.loadData()
    },
    modalDetailOk(){
      this.loadData()
    },
    modalDetailClose(){
      this.loadData()
    },
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
/deep/.ant-table-row-cell-break-word:empty:after {
  content: '--';
}
</style>